export const PER_SLOT = 'per_slot';
export const TOTAL = 'total';



// WEBPACK FOOTER //
// ./src/lib/cost-types.js